import { useTranslate } from 'ra-core';
import { ExportButton, type ExportButtonProps } from '../admin/export-button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../ui/tooltip';

export type ListExportButtonProps = ExportButtonProps &
  Required<Pick<ExportButtonProps, 'maxResults'>>;

/**
 * Export button with a tooltip that informs the user about the maximum number of records that can be exported.
 *
 * If the maxResults is `Infinity`, it will export an infinite number of records and show no tooltip.
 */
export const ListExportButton = ({
  maxResults,
  ...exportProps
}: ListExportButtonProps) => {
  const translate = useTranslate();

  if (!isFinite(maxResults)) {
    return <ExportButton {...exportProps} maxResults={Infinity} />;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        {/* A wrapper, so the tooltip also shows when the button is disabled (no records) */}
        <TooltipTrigger render={<span className="inline-flex" />}>
          <ExportButton {...exportProps} maxResults={maxResults} />
        </TooltipTrigger>
        <TooltipContent>
          {translate('moonstar.export.limit', { max: maxResults })}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
